export default __webpack_public_path__ + "static/media/Delete.f5aed63a.svg";